<template>
    <CashRegisterHome />
</template>

<script>
import CashRegisterHome from '@/components/cashRegister/CashRegisterHome.vue'
export default {
    name: 'CashRegisterHomeView',
    components: {
        CashRegisterHome
    }
}
</script>


